import { FlexboxVertical } from '../../styles/Layouts';
import styled, { useTheme } from 'styled-components';
import { FC, ReactNode } from 'react';
import { getTheme, ThemeProps } from '../../styles/Theme';
import { SectionWrapper } from '../common/SectionWrapper';
import { BREAKPOINT_SM } from '../../styles/General';
import { PageTitle } from '../../styles/FontStyles';
import { basicGridItem, BasicGridItemProps, BasicGridWrapper } from '../common/Grids';
import { ImageProps } from '../../utils/interfaces/Image';

const BasicGridWrapperCustom = styled(BasicGridWrapper)`
  align-items: center;
`;

const InnerWrapper = styled(FlexboxVertical)<BasicGridItemProps>`
  ${basicGridItem};
  margin: 5rem 0;
`;

const ImageWrapper = styled.div`
  border: 1px solid ${getTheme(({ colors }) => colors.purple)};
  margin-bottom: 2rem;
  width: 100%;
  display: flex;

  img {
    width: 100%;
    height: auto;
  }
`;

const PageTitleCustom = styled(PageTitle)`
  margin-bottom: 1.5rem;
  text-align: center;
`;

const SubHeadline = styled.p`
  margin-bottom: 2rem;
  text-align: center;
`;

const ChildrenWrapper = styled(FlexboxVertical)`
  width: 100%;
  justify-content: center;
  align-items: center;

  ${BREAKPOINT_SM} {
    flex-direction: row;
    margin: auto;
  }

  > button, a {
    margin: 0 .5rem 1rem .5rem;
  }
`;

interface LayoutCenteredProps {
  headline?: string;
  subHeadline?: string | ReactNode;
  image?: Partial<ImageProps>;
  className?: string;
}

export const LayoutCentered: FC<LayoutCenteredProps> = (props) => {

  const { headline, subHeadline, image, className, children } = props;
  const validUrlOptions = ['//', '/', 'http', 'https'];
  const completeUrl = validUrlOptions.some((option) => image?.url?.startsWith(option)) ? image?.url : `https://${image?.url}`;

  return (
    <SectionWrapper background={(useTheme() as ThemeProps).colors.lightPurple} center={true} className={className}>
      <BasicGridWrapperCustom>
        <InnerWrapper gridColLG={'6'} gridSpanLG={'4'}>
          {
            image &&
            <ImageWrapper>
              <img src={completeUrl} alt={image.name} />
            </ImageWrapper>
          }
          {
            headline &&
            <PageTitleCustom>
              {headline}
            </PageTitleCustom>
          }
          {
            subHeadline &&
            <SubHeadline>
              {subHeadline}
            </SubHeadline>
          }
          {
            children &&
            <ChildrenWrapper>
              {children}
            </ChildrenWrapper>
          }
        </InnerWrapper>
      </BasicGridWrapperCustom>
    </SectionWrapper>
  );
};

